import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'

type InitEditorStatePlugin = {
  savedEditorState: any // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default function InitEditorStatePlugin({ savedEditorState }: InitEditorStatePlugin) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (savedEditorState) {
      editor.update(() => {
        editor.setEditorState(editor.parseEditorState(savedEditorState))
      })
    }
  }, [editor, savedEditorState])

  return null
}
